import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
} from '@mui/material';
import CurrencyComponent from '../../../../../shared/components/Currency/Currency';
import { CONFIG_APP } from '../../../../../shared/const/app.config';

const REFUND_ELIGIBILITY_OPTION_KEYS = {
  eligible_for_refund: 'eligibleForRefund',
  eligible_redirected_reused: 'eligibleRedirectedReused',
  not_eligible_duplicate_policy: 'notEligibleDuplicatePolicy',
};

const getRefundEligibilityDisplay = (payment, t) => {
  const isRefundWithEligibility =
    (payment.transactionType === 'amendment' ||
      payment.transactionType === 'cancellation') &&
    Number(payment.amount) <= 0 &&
    payment.refundEligibility;

  if (!isRefundWithEligibility) {
    return '-';
  }

  const optionKey =
    REFUND_ELIGIBILITY_OPTION_KEYS[payment.refundEligibility];

  if (!optionKey) {
    return payment.refundEligibility;
  }

  return t(
    `POLICY_DETAILS.PAYMENT.refundEligibility.options.${optionKey}`,
    payment.refundEligibility,
  );
};

const PaymentsTable = ({ payments, policyDetails }) => {
  const { t } = useTranslation();
  return (
    <Grid item xs={12} className="transactions-container">
      <h4>{t('POLICY_DETAILS.PAYMENT.transactions')}</h4>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionType')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionDate')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionId')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.amount')}</TableCell>
            <TableCell className="refund-eligibility-cell">
              {t('POLICY_DETAILS.PAYMENT.refundEligibility.label')}
            </TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.status')}</TableCell>
            <TableCell className="message-cell">
              {t('POLICY_DETAILS.PAYMENT.message')}
            </TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.businessUnitId')}</TableCell>
            <TableCell>
              {t('POLICY_DETAILS.PAYMENT.claimedAgentUserId')}
            </TableCell>
          </TableHead>
          <TableBody>
            {payments.map((payment, index) => {
              const refundEligibilityDisplay = getRefundEligibilityDisplay(
                payment,
                t,
              );

              return (
              <TableRow key={index}>
                <TableCell>
                  {t(`POLICY_DETAILS.PAYMENT.${payment.transactionType}`)}
                </TableCell>
                <TableCell>
                  {format(
                    new Date(payment.createdDate),
                    CONFIG_APP.DATE_FORMAT,
                  )}
                </TableCell>
                <TableCell>{payment.transactionId}</TableCell>
                <TableCell>
                  <CurrencyComponent
                    value={payment.amount}
                    countryCode={policyDetails.policy.price.currency}
                  />
                </TableCell>
                <TableCell
                  className={`refund-eligibility-cell${
                    refundEligibilityDisplay === '-'
                      ? ' refund-eligibility-cell--empty'
                      : ''
                  }`}
                >
                  {refundEligibilityDisplay}
                </TableCell>
                <TableCell>{payment.status}</TableCell>
                <TableCell className="message-cell">
                  {payment.message}
                </TableCell>
                <TableCell>{payment.businessUnitId}</TableCell>
                <TableCell>{payment.claimedAgentUserId}</TableCell>
              </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

PaymentsTable.propTypes = {
  policyDetails: PropTypes.object,
  payments: PropTypes.object,
};
export default PaymentsTable;
